module.exports = __webpack_public_path__ + "static/flags/BQ-cfd5e8fba49fadb79a8e9f66529b25b3.gif";